import { eventBus } from "./eventBus";

export const SYNC_DASHBOARD_REFRESH_EVENT = "refresh-sync-dashboard";
export const OPPORTUNITIES_REFRESH_EVENT = "refresh-opportunities";

const dispatchWindowEvent = (eventName: string): void => {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(eventName));
  }
};

export const triggerSyncDashboardRefresh = (): void => {
  eventBus.emit(SYNC_DASHBOARD_REFRESH_EVENT);
  dispatchWindowEvent(SYNC_DASHBOARD_REFRESH_EVENT);
};

export const triggerOpportunityDataRefresh = (): void => {
  eventBus.emit(OPPORTUNITIES_REFRESH_EVENT);
  dispatchWindowEvent(OPPORTUNITIES_REFRESH_EVENT);
  triggerSyncDashboardRefresh();
};
